import React from 'react';
import { AdvertorialHeader } from './AdvertorialHeader';
import { AdvertorialSection } from './AdvertorialSection';
import { AdvertorialBulletPoints } from './AdvertorialBulletPoints';
import { AdvertorialCTA } from './AdvertorialCTA';
export const AdvertorialLanding: React.FC = () => {
  return <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-60">
      <AdvertorialHeader logo="https://images.unsplash.com/photo-1603302576837-37561b2e2302?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80" headline='Smarta Svenska Hundägare Använder "LedÅterställning™" För Att Få Stela, Haltande Hundar Att Springa Igen – Här Är Vetenskapen Bakom Det' subheadline="" heroImage="https://uploadthingy.s3.us-west-1.amazonaws.com/wRMq6cFwvuup7MiWGmK9G4/a5907663-a416-4a0e-98c2-7db57f35cf04.png" data-id="element-61" />
      <AdvertorialBulletPoints headline="De 7 Avslöjande Tecknen På Att Din Hunds Leder Bryts Ner" points={['Undviker att hoppa upp i sängen eller soffan', 'Problem med att gå upp eller ner för trappor', 'Ihållande slickande eller tuggande på leder', 'Haltar eller favoriserar ett ben', 'Frekventa halkor eller fall', 'Sover mer än vanligt', 'Övervikt som gör varje rörelse tyngre']} data-id="element-62" />
      <section className="w-full py-8 md:py-16 bg-white" data-id="element-63">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-64">
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-65">
            Dessa nödsignaler kommer direkt från lederna inne i din hunds kropp
            — särskilt de i axlar, armbågar, höfter och knän.
          </p>
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-66">
            Leder har två jobb.
          </p>
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-67">
            De kopplar ihop ben ungefär som ett gångjärn på en grind.
          </p>
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-68">
            Och de fungerar som stötdämpare så att hundar kan springa, hoppa och
            vända på ett öre.
          </p>
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-69">
            Normalt är varje led polstrad av ett tunt, skyddande lager av brosk
            för att dämpa benen från att gnida mot varandra.
          </p>
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-70">
            Men här är problemet: Detta kritiska lager av brosk kan börja slitas
            ner — och när det väl sker blir varje steg din hund tar fullt av
            värk och smärta.
          </p>
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-71">
            Och det som de flesta hundägare inte förstår är att det inte är
            brosket självt som är det verkliga problemet.
          </p>
          <p className="text-lg md:text-xl text-gray-700" data-id="element-72">
            Det är vad som händer under brosket som verkligen spelar roll.
          </p>
        </div>
      </section>
      <AdvertorialSection headline="Den Riktiga Orsaken: Din Hund Blir Inte Stel Av Ålder—Utan För Att Ledvätskan Torkar Ut" image="https://uploadthingy.s3.us-west-1.amazonaws.com/dJmCnbiZLvR6Vx9HyQ9Uvj/c34ff64d-f647-4969-9fea-2d96f920a4b2.png" content={['Inne i varje led finns det en vätska — ledvätskan (den synoviala vätskan) — som fungerar som kroppens naturliga "ledolja".', '', 'Den gör att brosket kan glida mjukt utan friktion, precis som olja i en motor.', '', 'Men med tiden börjar denna vätska torka ut.', '', 'När ledvätskan tunnas ut uppstår friktion.', '', 'Benen börjar skava mot varandra.', '', 'Och varje steg gör ont.', '', 'Det är som att försöka öppna en rostig grind.', '', 'Utan smörjmedel knakar den, fastnar och gör ont att röra.', '', 'Det är exakt vad som händer inne i din hunds leder.', '', 'Och här är vad som gör saken värre:', '', 'De flesta hundägare märker inte problemen förrän deras hund redan har förlorat 60-70% av sin ledvätska.', '', 'Vid det laget har skadorna pågått i månader, ibland år.', '', 'Det är därför hundar som brukade springa till dörren när du kom hem nu knappt kan resa sig från sin säng på morgonen.', '', 'Det är därför hundar som brukade hoppa upp i soffan för kvällsmys nu tittar upp på dig med blicken som säger "Jag vill, men jag kan inte."', '', 'Det är därför hundar som brukade leka med bollen i timmar nu lämnar den orörda i hörnet.', '', 'Men här är den goda nyheten: När du återfuktar den torkade ledvätskan kan din hund röra sig mjukt igen, sova lugnt och få tillbaka sin livsglädje.', '', 'När hundägare äntligen känner igen tecknen börjar de leta efter sätt att hjälpa — vilket för oss till nästa ämne...']} reverse={true} data-id="element-73" />
      <AdvertorialSection headline="De Allvarliga Riskerna Med Moderna Läkemedel" image="https://uploadthingy.s3.us-west-1.amazonaws.com/7MXx5wkbEMw4caiP72cEbh/-_Jennifer_%285%29.jpg" content={['När din hund har ont verkar NSAID:er som det självklara valet — icke-steroida antiinflammatoriska läkemedel.', '', 'De lättar stelhet, förbättrar rörligheten, och under en liten stund ser din hund ut som att den är tillbaka till det normala.', '', 'Här är haken: Dessa mediciner gör ingenting för ledhälsan.', '', 'De blockerar bara smärtan.', '', 'Så medan din hund kan verka bättre på utsidan fortsätter skadorna inuti att bli värre.', '', 'För att inte tala om att NSAID:er belastar tyst levern, njurarna och matsmältningssystemet — vilket kan leda till kräkningar, magsår eller mer allvarliga problem om de används för ofta.', '', 'Med andra ord kan den tillfälliga lindringen komma till en mycket större kostnad längre fram.']} data-id="element-74" />
      <AdvertorialSection headline="Varför De Flesta Tillskott Misslyckas" image="https://uploadthingy.s3.us-west-1.amazonaws.com/tvfXedL44Xa33s8XC1Zaov/-_Jennifer_%284%29.jpg" content={['Kanske har du redan prövat glukosamin-tuggisar eller MSM-pulver.', '', 'Och kanske märkte du en liten förbättring... under ett par veckor.', '', 'Sedan började din hund halta igen.', '', 'Här är varför:', '', 'De flesta tillskott fokuserar bara på ett enda steg i ledhälsan — ofta glukosamin eller hyaluronsyra.', '', 'Men utan rätt stödämnen kan kroppen inte använda dessa ämnen.', '', 'Tänk på det så här: Om du försöker fylla en tank med ett hål i botten kommer vattnet aldrig att stanna.', '', 'Du behöver täppa till hålet först innan du fyller på.', '', 'Det är precis vad som händer med de flesta ledtillskott.', '', 'De försöker "fylla på" ledvätskan, men utan kollagen för att hålla den på plats och vitamin C för att hjälpa kroppen att absorbera den, går det mesta av det till spillo.', '', 'Verkligt ledstöd måste göra mer än att bara maskera symptomen.', '', 'Det måste skydda och reparera det som bryts ner inne i din hunds kropp — utan att orsaka skadliga bieffekter.', '', 'Den goda nyheten är att det finns en lösning som uppfyller alla dessa kriterier:']} reverse={true} data-id="element-75" />
      <AdvertorialSection headline="Prova Den Nya, Veterinärgodkända 5-Sekunders Vattenskåls-Ritualen Som Får Haltande Hundar Att Springa Igen" image="https://uploadthingy.s3.us-west-1.amazonaws.com/ekAm2we3Pve9ZkBU93VQ1q/-_Jennifer_%286%29.jpg" content={['Pawzpy LedLycka skapades av två frustrerade hundägare som tillbringade år med att försöka lösa deras hunds smärtsamma ledproblem.', '', 'Till en början prövade de alla vanliga "lösningar" och var uttråkade efter att de gjorde mer skada än nytta.', '', 'Så de tog saken i egna händer och samarbetade med en världsberömd djurnutritionist med många års erfarenhet för att utveckla något som går långt över allt annat.', '', 'Resultatet är 5-sekunders vattenskåls-ritualen™ — en enkel daglig rutin där du tillsätter smakfria droppar i din hunds mat eller vatten.', '', 'Inga tabletter.', '', 'Inget bråk.', '', 'Bara 5 sekunder som kan förändra din hunds liv.', '', 'Men här är den verkliga genialiteten bakom LedLycka:']} data-id="element-76" />
      <AdvertorialSection headline="Vad du ALDRIG ska ge en hund med artros (och den skandinaviska lösningen som får dem att springa fritt istället)" image="https://images.unsplash.com/photo-1587300003388-59208cc962cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80" content={['De flesta produkter innehåller bara hyaluronsyra — vilket visserligen är ledvätskans huvudkomponent och fungerar som en "vattenmagnet" som drar in fukt i leden.', '', 'Men här är problemet:', '', 'Hos hundar absorberas upp till 80% av hyaluronsyran inte alls när den ges ensam.', '', 'Den passerar bara genom systemet utan att någonsin nå lederna.', '', 'Resultatet blir att effekten uteblir — oavsett hur mycket du ger.', '', 'Det är som att hälla vatten i en hink med ett hål i botten.', '', 'Du kan fortsätta fylla på, men inget stannar kvar.']} data-id="element-77" />
      <section className="w-full py-8 md:py-16 bg-blue-50" data-id="element-78">
        <div className="container mx-auto px-4" data-id="element-79">
          <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-8 text-center" data-id="element-80">
            5-Sekunders Lösningen: Två Ingredienser Som Arbetar Tillsammans
          </h2>
          <div className="max-w-4xl mx-auto mb-8" data-id="element-81">
            <p className="text-lg md:text-xl text-gray-700 mb-6" data-id="element-82">
              LedLycka använder en kraftfull synergi av två nyckelingredienser
              som arbetar tillsammans för att återfukta och behålla ledvätskan:
            </p>
          </div>
          <div className="max-w-4xl mx-auto space-y-6 mb-8" data-id="element-83">
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-md" data-id="element-84">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-3 flex items-center" data-id="element-85">
                <span className="text-2xl mr-3" data-id="element-86">🔹</span>
                Hyaluronsyra - Vattenmagnet
              </h3>
              <p className="text-lg md:text-xl text-gray-700" data-id="element-87">
                Fungerar som en kraftfull "vattenmagnet" som drar in och binder
                vätska i leden. Det är detta som återställer den naturliga
                smörjningen så att rörelserna blir mjuka och smärtfria igen.
              </p>
            </div>
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-md" data-id="element-88">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-3 flex items-center" data-id="element-89">
                <span className="text-2xl mr-3" data-id="element-90">🔹</span>
                Vitamin C - Låser In Fukten
              </h3>
              <p className="text-lg md:text-xl text-gray-700" data-id="element-91">
                Här är den saknade pusselbiten: Vitamin C stimulerar kroppens
                egen produktion av stödvävnad och ökar drastiskt upptaget av
                hyaluronsyran i lederna. Utan vitamin C går det mesta till
                spillo. Med vitamin C stannar det kvar där det gör nytta — inne
                i leden.
              </p>
            </div>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-92">
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-93">
              Tillsammans skapar dessa två en självförstärkande effekt:
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-6 font-semibold text-center bg-white p-4 rounded-lg" data-id="element-94">
              Hyaluronsyran återfuktar → Vitamin C låser in fukten → Leden
              förblir smord och flexibel
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-95">
              Plus, eftersom LedLycka levereras i flytande form, når
              ingredienserna blodet tillsammans och absorberas där de behövs —
              något tabletter och pulver aldrig kan uppnå lika effektivt.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-96">
              Och till skillnad från tabletter eller tuggisar som hundar spottar
              ut, är LedLycka helt smaklöst — det försvinner i maten eller
              vattnet utan dramatik.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-97">Ingen kamp.</p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-98">
              Bara 5 sekunder vid vattenskålen, och du är klar.
            </p>
            <p className="text-lg md:text-xl text-gray-700 italic" data-id="element-99">
              Observera: LedLycka innehåller också en liten mängd kollagen typ
              II som stödjer långsiktig ledhälsa, men kärnan i formeln är den
              kraftfulla kombinationen av hyaluronsyra + vitamin C.
            </p>
          </div>
        </div>
      </section>
      <section className="w-full py-8 md:py-16 bg-white" data-id="element-100">
        <div className="container mx-auto px-4" data-id="element-101">
          <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-8 text-center" data-id="element-102">
            Fall Inte För De Där Billiga Imitationerna
          </h2>
          <div className="max-w-4xl mx-auto mb-8" data-id="element-103">
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-104">
              Du har sett massor av ledhälsotillskott som kantar hyllorna i din
              lokala djuraffär.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-105">
              Men de flesta lever inte upp till deras bild.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-106">
              De är gjorda med billiga ingredienser, svaga doser och syntetiska
              fyllmedel som skär hörn — men gör ingenting för din hund.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-107">
              Precis som de otaliga humantillskotten som misslyckas i oberoende
              laboratorietester, kommer många hundformler inte upp till vad som
              utlovas på etiketten — vilket lämnar desperata hundägare kände sig
              lurade.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-108">
              Det är därför det är så viktigt att hitta en formel som är byggd
              för att fungera — med ordentlig testning, beprövade ingredienser
              och doser som levererar verkliga resultat.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-109">
              Pawzpy LedLycka skapades för att möta den högre standarden.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-8" data-id="element-110">
              Varje batch produceras med den svenska fomulan med
              premiumingredienser av humankvalitet och testas av ett
              tredjepartslaboratorium för kvalitet och styrka.
            </p>
            <p className="text-xl md:text-2xl font-semibold text-blue-900 mb-6 text-center" data-id="element-111">
              Här är en smakprov av vad din hund kan förvänta sig att hitta i
              varje smaklös droppe:
            </p>
          </div>
          <div className="max-w-4xl mx-auto space-y-6" data-id="element-112">
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md border-l-4 border-blue-600" data-id="element-113">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-4" data-id="element-114">
                Hyaluronsyra - Vattenmagnet
              </h3>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-115">
                Huvudkomponenten i ledvätskan.
              </p>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-116">
                Den fungerar som en kraftfull "vattenmagnet" som drar in och
                binder vätska i leden.
              </p>
              <p className="text-lg md:text-xl text-gray-700" data-id="element-117">
                Hyaluronsyra är det som återställer den naturliga smörjningen så
                att ledvätskan blir trögflytande och "oljar" leden — vilket
                minskar friktion och gör att varje rörelse blir mjuk och
                smärtfri.
              </p>
            </div>
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md border-l-4 border-blue-600" data-id="element-118">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-4" data-id="element-119">
                Vitamin C - Absorption Booster
              </h3>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-120">
                Den kritiska katalysatorn som gör allt möjligt.
              </p>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-121">
                Utan vitamin C absorberas endast 20% av hyaluronsyran — med
                vitamin C når upp till 80% lederna.
              </p>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-122">
                Vitamin C förbättrar också kroppens egen förmåga att bygga
                stödvävnad, vilket betyder att effekten håller längre.
              </p>
              <p className="text-lg md:text-xl text-gray-700" data-id="element-123">
                Utan denna ingrediens går det mesta av hyaluronsyran till
                spillo.
              </p>
            </div>
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md border-l-4 border-blue-600" data-id="element-124">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-4" data-id="element-125">
                Hydrolyserat Kollagen Typ II - Långsiktigt Stöd
              </h3>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-126">
                Stödjer långsiktig ledhälsa genom att hjälpa kroppen bygga upp
                stödvävnad över tid.
              </p>
              <p className="text-lg md:text-xl text-gray-700" data-id="element-127">
                Kollagen fungerar i bakgrunden för att hjälpa kroppen underhålla
                friska leder på sikt, men kärnan i formeln är den kraftfulla
                kombinationen av hyaluronsyra + vitamin C.
              </p>
            </div>
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md border-l-4 border-blue-600" data-id="element-128">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-4" data-id="element-129">
                D-Biotin - Bonus för Helhälsa
              </h3>
              <p className="text-lg md:text-xl text-gray-700 mb-3" data-id="element-130">
                En bonus för övergripande hälsa.
              </p>
              <p className="text-lg md:text-xl text-gray-700" data-id="element-131">
                Biotin stärker vävnad, päls och klor — så när din hund börjar
                känna sig bättre och vill gräva och leka igen, är den redo för
                det.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="w-full py-8 md:py-16 bg-white" data-id="element-132">
        <div className="container mx-auto px-4" data-id="element-133">
          <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-8 text-center" data-id="element-134">
            Förbättra Din Hunds Rörlighet Och Livskvalitet I 4 Enkla Steg Eller
            Få Pengarna Tillbaka
          </h2>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-135">
            <p className="text-lg md:text-xl text-gray-700 mb-8 text-center" data-id="element-136">
              Pawzpy LedLycka är designad för att fungera i 4 stadier med
              synliga resultat som dyker upp på så lite som 2 veckor och mer
              dramatiska förändringar som byggs upp över tid.
            </p>
          </div>
          <ul className="space-y-6 max-w-3xl mx-auto mb-8" data-id="element-137">
            <li className="bg-blue-50 p-6 rounded-lg" data-id="element-138">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-3 flex items-start" data-id="element-139">
                <span className="text-2xl mr-3" data-id="element-140">🔹</span>
                <span data-id="element-141">De första 4 veckorna: Komfortstadiet</span>
              </h3>
              <p className="text-lg md:text-xl text-gray-700 ml-9" data-id="element-142">
                De kraftfulla ingredienserna i varje droppe hjälper till att
                lugna inflammation och ta tryck från din hunds leder. Du märker
                att din hund reser sig snabbare, rör sig lättare och börjar
                kännas som sig själv igen.
              </p>
            </li>
            <li className="bg-blue-50 p-6 rounded-lg" data-id="element-143">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-3 flex items-start" data-id="element-144">
                <span className="text-2xl mr-3" data-id="element-145">🔹</span>
                <span data-id="element-146">Vecka 4-6: Återuppbyggnadsstadiet</span>
              </h3>
              <p className="text-lg md:text-xl text-gray-700 ml-9" data-id="element-147">
                Nu när obehaget är under kontroll kan din hunds kropp växla till
                reparationsläge. Varje dropp levererar nyckelingredienser som
                hjälper till att återställa skadat brosk och återuppbygga den
                naturliga dämpningen inne i lederna — delen som håller varje
                steg mjukt och stadigt.
              </p>
            </li>
            <li className="bg-blue-50 p-6 rounded-lg" data-id="element-148">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-3 flex items-start" data-id="element-149">
                <span className="text-2xl mr-3" data-id="element-150">🔹</span>
                <span data-id="element-151">Vecka 7-9: Rörlighets-stadiet</span>
              </h3>
              <p className="text-lg md:text-xl text-gray-700 ml-9" data-id="element-152">
                Starkare leder betyder mer frihet. Du märker mer energi, längre
                promenader och en växande iver att leka. Under det hela blir din
                hunds leder mer stabila och stöttade. Det här är när många
                hundägare rapporterar den magiska stunden — första gången de ser
                sin hund springa till dörren igen när de kommer hem.
              </p>
            </li>
            <li className="bg-blue-50 p-6 rounded-lg" data-id="element-153">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-3 flex items-start" data-id="element-154">
                <span className="text-2xl mr-3" data-id="element-155">🔹</span>
                <span data-id="element-156">Vecka 10-12: Underhållsstadiet</span>
              </h3>
              <p className="text-lg md:text-xl text-gray-700 ml-9" data-id="element-157">
                I detta sista stadium rör sig din hunds kropp som den ska igen —
                stadig, stark och smärtfri. Stelheten är borta. Energin är
                tillbaka. Och dropparna fungerar nu som ett underhållsverktyg
                som hjälper till att hålla lederna närda, brosket skyddat och
                slitaget i schack så att din hund kan förbli aktiv på lång sikt.
              </p>
            </li>
          </ul>
          <div className="max-w-3xl mx-auto bg-blue-50 p-6 md:p-8 rounded-lg" data-id="element-158">
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-159">
              Pawzpy är säker på kvaliteten och effektiviteten hos dessa
              droppar.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-160">
              Det är därför varje flaska backas upp med en 60-dagars
              pengarna-tillbaka-garanti.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-161">
              Du kan prova dem riskfritt i 2 månader och bevittna din hunds
              transformation själv.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-162">
              Och om du inte älskar resultaten du ser under den tiden får du en
              problemfri återbetalning av hela ditt köpbelopp — inga frågor
              ställda.
            </p>
          </div>
        </div>
      </section>
      <section className="w-full py-8 md:py-16 bg-white" data-id="element-163">
        <div className="container mx-auto px-4" data-id="element-164">
          <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-8 text-center" data-id="element-165">
            Framgångshistorier Från Glada Hundägare
          </h2>
          <div className="max-w-4xl mx-auto space-y-8" data-id="element-166">
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md" data-id="element-167">
              <p className="text-lg md:text-xl text-gray-700 mb-4 italic" data-id="element-168">
                "Min hund fyller 11 år och vi har nyligen lagt till en ny valp i
                vårt hem. Dessa har hjälpt henne att vara mer lekfull och inte
                ha ont. Hon springer till dörren igen när jag kommer hem - något
                hon inte gjort på över ett år."
              </p>
              <p className="text-base md:text-lg font-semibold text-blue-900" data-id="element-169">
                — Anna, Stockholm
              </p>
            </div>
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md" data-id="element-170">
              <p className="text-lg md:text-xl text-gray-700 mb-4 italic" data-id="element-171">
                "Det här har hjälpt min hund sååååå mycket, hon är 12 år gammal
                med dåliga höfter och det här har gjort underverk för henne. Jag
                kan inte förklara hur mycket det har hjälpt!! Hon hoppar upp i
                soffan igen utan att tveka."
              </p>
              <p className="text-base md:text-lg font-semibold text-blue-900" data-id="element-172">
                — Erik, Göteborg
              </p>
            </div>
            <div className="bg-blue-50 p-6 md:p-8 rounded-lg shadow-md" data-id="element-173">
              <p className="text-lg md:text-xl text-gray-700 mb-4 italic" data-id="element-174">
                "Min hund kommer att bli 13 år om ett par månader och den här
                produkten har haft sådan inverkan på hans liv. Hans rörelser när
                han klättrar i trappor har blivit så mycket lättare för honom.
                Jag har till och med sett honom springa i trädgården vilket
                verkligen är en prestation för honom."
              </p>
              <p className="text-base md:text-lg font-semibold text-blue-900" data-id="element-175">
                — Maria, Malmö
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="w-full py-8 md:py-16 bg-blue-50" data-id="element-176">
        <div className="container mx-auto px-4" data-id="element-177">
          <div className="max-w-3xl mx-auto text-center" data-id="element-178">
            <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-179">
              Pawzpys djupa kärlek till husdjur har förvandlats till en levande
              online-gemenskap som är engagerad i att förbättra din hunds hälsa
              och lycka.
            </p>
            <p className="text-lg md:text-xl text-gray-700" data-id="element-180">
              Det är därför varje droppe skapas med exakta doser av
              vetenskapligt bevisade ingredienser för att ge din bästa vän de
              verkliga, långvariga resultaten den förtjänar.
            </p>
          </div>
        </div>
      </section>
      <AdvertorialCTA headline="45% Rabatt På Din Första Beställning" subheadline="" productImage="https://images.unsplash.com/photo-1567752881298-894bb81f9379?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2680&q=80" price="" originalPrice="" buttonText="KONTROLLERA TILLGÄNGLIGHET" buttonLink="https://pawzpy.com/products/ledlycka-fa-hennes-livsgladje-tillbaka" guarantee="60 dagars pengarna-tillbaka-garanti" data-id="element-181" />
      <section className="w-full py-8 md:py-16 bg-white" data-id="element-182">
        <div className="container mx-auto px-4" data-id="element-183">
          <div className="max-w-3xl mx-auto text-center" data-id="element-184">
            <p className="text-xl md:text-2xl text-gray-700 mb-4" data-id="element-185">
              Denna hälsoformel är designad för att hjälpa alla hundar i alla
              åldrar.
            </p>
            <p className="text-xl md:text-2xl text-gray-700 mb-4" data-id="element-186">
              Sanningen är att hundar inte ber om mycket, men de fyller våra liv
              med oändliga mängder glädje.
            </p>
            <p className="text-xl md:text-2xl text-gray-700 mb-4" data-id="element-187">
              Det är bara rättvist att vi gör detsamma för dem.
            </p>
            <p className="text-xl md:text-2xl text-gray-700 mb-4" data-id="element-188">
              Och nu kan du — genom att stödja deras ledhälsa med
              premiumingredienser.
            </p>
            <p className="text-xl md:text-2xl text-gray-700 mb-8" data-id="element-189">
              Prova Pawzpy LedLycka riskfritt idag och rapportera dina resultat
              tillbaka så att vi kan dela din framgångshistoria!
            </p>
            <div className="mt-12 pt-8 border-t border-gray-300" data-id="element-190">
              <p className="text-xs md:text-sm text-gray-600 mb-3 font-semibold" data-id="element-191">
                DETTA ÄR EN ANNONS OCH INTE EN FAKTISK NYHETSARTIKEL, BLOGG
                ELLER KONSUMENTSKYDDSUPPDATERING.
              </p>
              <p className="text-xs md:text-sm text-gray-600 mb-3" data-id="element-192">
                Detta är en annons för Pawzpy och är endast avsedd för
                informationsändamål.
              </p>
              <p className="text-xs md:text-sm text-gray-600 mb-3" data-id="element-193">
                All information som tillhandahålls av Pawzpy utgör inte
                medicinsk rådgivning och ska inte användas som ersättning för
                veterinärrådgivning.
              </p>
              <p className="text-xs md:text-sm text-gray-600 mb-3" data-id="element-194">
                Vänligen konsultera din veterinär angående eventuella ändringar
                i behandling eller tillskott.
              </p>
              <p className="text-xs md:text-sm text-gray-600 mb-3" data-id="element-195">
                Åsikterna som uttrycks är enbart Pawzpys eller ett vittnesbörd
                från en verifierad Pawzpy-kund baserat på hans/hennes verkliga
                upplevelser.
              </p>
              <p className="text-xs md:text-sm text-gray-600 mb-3" data-id="element-196">
                Individuella resultat kan variera.
              </p>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-197">
                Observera att Pawzpy-produkter inte är läkemedel och är inte
                avsedda att behandla, förebygga eller bota någon sjukdom.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};